module.exports = __webpack_public_path__ + "static/media/ic_operator_plus.63acc880.svg";